import { useSegmentIdentify } from "@/hooks/use-segment-identify";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { ReactNode } from "react";

export const analytics = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_KEY });

/*
 * SegmentInitializer component
 * We needed this to initialize the segment analytics
 * This is a workaround for it to sit inside the QueryClientProvider as we can't
 * call the session query outside of it.
 */
export const SegmentInitializer = ({ children }: { children: ReactNode }) => {
  useSegmentIdentify();
  return children;
};
